// extracted by mini-css-extract-plugin
module.exports = {"svg":"Icons_svg__165EO","rotation-90":"Icons_rotation-90__1kl8n","rotation90":"Icons_rotation90__wT7V1","rotation180":"Icons_rotation180__RYfmM"};